import axios from 'axios'

const API_BASE_URL = 'http://localhost:13000/api/v1'

export interface Consumable {
  id: string
  tenant_id: string
  item_name: string
  category: string
  status: string
  location: string
  quantity_on_hand: number
  unit_of_measure: string
  reorder_level: number
  reorder_quantity: number
  supplier?: string
  unit_cost?: number
  expiration_date?: string
  batch_number?: string
  description?: string
  created_at: string
  updated_at: string
}

export interface CreateConsumableRequest {
  item_name: string
  category: string
  status: string
  location: string
  quantity_on_hand: number
  unit_of_measure: string
  reorder_level: number
  reorder_quantity: number
  supplier?: string
  unit_cost?: number
  expiration_date?: string
  batch_number?: string
  description?: string
}

export interface ConsumableListResponse {
  items: Consumable[]
  total: number
  skip: number
  limit: number
}

class ConsumablesService {
  async listConsumables(
    skip: number = 0,
    limit: number = 50,
    filters?: {
      status?: string
      location?: string
      category?: string
    }
  ): Promise<ConsumableListResponse> {
    try {
      const params = new URLSearchParams()
      params.append('skip', String(skip))
      params.append('limit', String(limit))

      if (filters?.status) {
        params.append('status', filters.status)
      }
      if (filters?.location) {
        params.append('location', filters.location)
      }
      if (filters?.category) {
        params.append('category', filters.category)
      }

      const response = await axios.get(`${API_BASE_URL}/equipment/consumables?${params.toString()}`)
      return response.data
    } catch (error) {
      console.error('Error listing consumables:', error)
      throw error
    }
  }

  async getConsumable(id: string): Promise<Consumable> {
    try {
      const response = await axios.get(`${API_BASE_URL}/equipment/consumables/${id}`)
      return response.data
    } catch (error) {
      console.error(`Error fetching consumable ${id}:`, error)
      throw error
    }
  }

  async createConsumable(data: CreateConsumableRequest): Promise<Consumable> {
    try {
      const response = await axios.post(`${API_BASE_URL}/equipment/consumables`, data)
      return response.data
    } catch (error) {
      console.error('Error creating consumable:', error)
      throw error
    }
  }

  async updateConsumable(id: string, data: Partial<CreateConsumableRequest>): Promise<Consumable> {
    try {
      const response = await axios.put(`${API_BASE_URL}/equipment/consumables/${id}`, data)
      return response.data
    } catch (error) {
      console.error(`Error updating consumable ${id}:`, error)
      throw error
    }
  }

  async deleteConsumable(id: string): Promise<void> {
    try {
      await axios.delete(`${API_BASE_URL}/equipment/consumables/${id}`)
    } catch (error) {
      console.error(`Error deleting consumable ${id}:`, error)
      throw error
    }
  }
}

export const consumablesService = new ConsumablesService()
